import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col,Row } from "reactstrap";
import { IMAGE_GALLERY } from "../../../Constant";
import { H5 } from "../../../AbstractElements";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";

const ListOfImage = ({ smallImages }) => {
  return (
    <Fragment>
      {smallImages.length > 0 && (
        <Col sm="12">
          <Card>
            <CardHeader className="pb-0">
              <H5>{IMAGE_GALLERY}</H5>
            </CardHeader>
            <CardBody className="my-gallery">
              <Row>
                <Gallery>
                  {smallImages &&
                    smallImages.map((item, i) => {
                      return (
                        <figure className="col-xl-3 col-sm-6" key={i}>
                          <Item
                            original={require(`../../../assets/images/${item}`)}
                            width="1024"
                            height="768"
                          >
                            {({ ref, open }) => (
                              <Link onClick={open}>
                                <img
                                  className="img-thumbnail"
                                  ref={ref}
                                  src={require(`../../../assets/images/${item}`)}
                                  alt=""
                                />
                              </Link>
                            )}
                          </Item>
                        </figure>
                      );
                    })}
                </Gallery>
              </Row>
            </CardBody>
          </Card>
        </Col>
      )}
    </Fragment>
  );
};
export default ListOfImage;